var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-top"},[_c('div',{staticClass:"logo"},[_c('img',{staticClass:"mid cursor",attrs:{"src":require("../assets/logo-r.png")},on:{"click":function($event){return _vm.$router.push('/customer/shop/shopIndex')}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }